/* VETORA – LPV2 landing page scripts (scoped: vetora-lpv2) */
(function () {
  'use strict';
  if (window.__vetoraLpv2Init) return;
  window.__vetoraLpv2Init = true;
  var P = 'vetora-lpv2';

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- sliders (scroll-snap + arrows + dots + autoplay) ---------- */
  function initSlider(root) {
    var track = root.querySelector('.' + P + '-slider__track');
    if (!track) return;
    var slides = qsa('.' + P + '-slider__slide', track);
    var dotsWrap = root.querySelector('.' + P + '-slider__dots');
    var prev = root.querySelector('[data-lpv2-prev]');
    var next = root.querySelector('[data-lpv2-next]');
    var autoplay = parseInt(root.getAttribute('data-lpv2-autoplay') || '0', 10);
    var timer = null, paused = false, current = 0;
    var isRTL = (getComputedStyle(track).direction === 'rtl');

    function slideWidth() { return slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth; }
    function gap() { var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0'); return isNaN(g) ? 0 : g; }
    function perView() { var w = slideWidth() + gap(); return Math.max(1, Math.round((track.clientWidth + gap()) / w)); }
    function pages() { return Math.max(1, slides.length - perView() + 1); }
    function absScroll() { return Math.abs(track.scrollLeft); }
    function indexFromScroll() { var w = slideWidth() + gap(); return w ? Math.round(absScroll() / w) : 0; }
    function goTo(i) {
      var total = pages();
      if (i < 0) i = total - 1;
      if (i > total - 1) i = 0;
      var w = slideWidth() + gap();
      var x = i * w;
      track.scrollTo({ left: isRTL ? -x : x, behavior: 'smooth' });
      current = i;
      render();
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var total = pages();
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = P + '-slider__dot'; b.setAttribute('aria-label', (i + 1) + ' / ' + total);
        (function (idx) { b.addEventListener('click', function () { goTo(idx); restart(); }); })(i);
        dotsWrap.appendChild(b);
      }
    }
    function render() {
      if (dotsWrap) qsa('.' + P + '-slider__dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      var loop = root.hasAttribute('data-lpv2-loop');
      if (prev) prev.disabled = !loop && current <= 0;
      if (next) next.disabled = !loop && current >= pages() - 1;
    }
    function restart() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { if (!paused) goTo(current + 1); }, autoplay); }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); restart(); });
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { current = Math.min(indexFromScroll(), pages() - 1); render(); }, 80); }, { passive: true });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 1500); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); current = Math.min(current, pages() - 1); render(); });
    buildDots(); render(); restart();
  }
  qsa('[data-lpv2-slider]').forEach(initSlider);

  /* ---------- accordions ---------- */
  qsa('[data-lpv2-accordion]').forEach(function (acc) {
    var items = qsa('[data-lpv2-acc-item]', acc);
    var single = acc.getAttribute('data-lpv2-accordion') !== 'multi';
    items.forEach(function (item) {
      var btn = item.querySelector('[data-lpv2-acc-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-active');
        if (single) items.forEach(function (o) { o.classList.remove('is-active'); var b = o.querySelector('[data-lpv2-acc-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); });
        item.classList.toggle('is-active', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  });

  /* ---------- offer: purchase toggle ---------- */
  qsa('[data-lpv2-offer]').forEach(function (offer) {
    var input = offer.querySelector('[data-lpv2-toggle]');
    function apply() {
      var sub = input ? input.checked : false;
      offer.classList.toggle('is-sub', sub);
      qsa('[data-lpv2-mode]', offer).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-lpv2-mode') === (sub ? 'sub' : 'once')); });
    }
    if (input) input.addEventListener('change', apply);
    apply();
  });

  /* ---------- sticky ATC + header fade (mobile) ---------- */
  (function () {
    var sticky = document.querySelector('[data-lpv2-sticky]');
    var header = document.querySelector('[data-lpv2-header]');
    if (!sticky) return;
    var offer = document.getElementById('order-now-section') || document.querySelector('[data-lpv2-offer]');
    var last = null;
    function handle() {
      if (window.innerWidth > 749) { sticky.classList.remove('is-visible'); if (header) header.classList.remove('is-hidden'); last = null; return; }
      var y = window.scrollY, h = window.innerHeight, inOffer = false;
      if (offer) {
        var top = offer.getBoundingClientRect().top + y, oh = offer.offsetHeight;
        inOffer = (y + h / 2 > top - 200) && (y < top + oh);
      }
      var show = y > 350 && !inOffer;
      if (show && last !== 'v') { last = 'v'; sticky.classList.add('is-visible'); if (header) header.classList.add('is-hidden'); }
      else if (!show && last !== 'h') { last = 'h'; sticky.classList.remove('is-visible'); if (header) header.classList.remove('is-hidden'); }
    }
    window.addEventListener('scroll', handle, { passive: true });
    window.addEventListener('resize', handle);
    handle();
  })();

  /* ---------- header drawer ---------- */
  (function () {
    var drawer = document.querySelector('[data-lpv2-drawer]');
    if (!drawer) return;
    qsa('[data-lpv2-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.classList.add('is-open'); }); });
    qsa('[data-lpv2-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { drawer.classList.remove('is-open'); }); });
  })();

  /* ---------- UGC videos ---------- */
  qsa('[data-lpv2-video]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    if (!v) return;
    wrap.addEventListener('click', function () {
      if (v.paused) { qsa('[data-lpv2-video] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-lpv2-video]').classList.remove('is-playing'); } }); v.play(); wrap.classList.add('is-playing'); }
      else { v.pause(); wrap.classList.remove('is-playing'); }
    });
    v.addEventListener('ended', function () { wrap.classList.remove('is-playing'); });
  });

  /* ---------- review "read more" (shown only when the text is really clipped) ----------
     Each [data-lpv2-more] button belongs to the closest preceding [data-lpv2-clamp] text.
     The button is visible only while the text overflows its CSS line-clamp in the CURRENT
     layout (measured, not counted by characters), and it re-measures after fonts load,
     on resize / orientation change and whenever the text box changes size (ResizeObserver),
     so slides that were laid out off-screen are handled too. Each card toggles on its own. */
  (function () {
    var pairs = [];
    qsa('[data-lpv2-more]').forEach(function (btn) {
      var text = null, el = btn.previousElementSibling;
      while (el && !el.hasAttribute('data-lpv2-clamp')) el = el.previousElementSibling;
      text = el || (btn.parentElement && btn.parentElement.querySelector('[data-lpv2-clamp]'));
      if (!text) { btn.hidden = true; return; }
      var more = btn.getAttribute('data-lpv2-more-label') || btn.textContent;
      var less = btn.getAttribute('data-lpv2-less-label') || more;
      var pair = { btn: btn, text: text, expanded: false };
      function measure() {
        if (pair.expanded) { btn.hidden = false; return; }
        /* scrollHeight > clientHeight only when the clamp actually hides a line */
        var clipped = text.scrollHeight - text.clientHeight > 1;
        btn.hidden = !clipped;
      }
      pair.measure = measure;
      btn.addEventListener('click', function () {
        pair.expanded = !pair.expanded;
        text.classList.toggle('is-expanded', pair.expanded);
        text.classList.toggle(P + '-rcard__text--full', pair.expanded);
        btn.textContent = pair.expanded ? less : more;
        btn.setAttribute('aria-expanded', String(pair.expanded));
        if (!pair.expanded) measure();
      });
      pairs.push(pair);
      if ('ResizeObserver' in window) { new ResizeObserver(function () { measure(); }).observe(text); }
    });
    if (!pairs.length) return;
    /* synchronous on purpose: requestAnimationFrame never fires while the tab is in the
       background, so a page opened in a background tab would keep the buttons hidden. */
    function measureAll() { pairs.forEach(function (p) { p.measure(); }); }
    var deb = null;
    function measureSoon() { clearTimeout(deb); deb = setTimeout(measureAll, 60); }
    measureAll();
    window.addEventListener('load', measureAll);
    window.addEventListener('resize', measureSoon);
    window.addEventListener('orientationchange', measureSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);
    document.addEventListener('shopify:section:load', measureAll);
  })();

  /* ---------- smooth anchor scroll for CTA links ---------- */
  qsa('a[href^="#"].' + P + '-cta, a[href^="#"].' + P + '-sticky__btn').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1); var el = id && document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();
